import { captureMessage } from "@sentry/vue";

import type { ApiError } from "@/Services/Api/Models";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { postAssigmentPatient } from "@/Services/TherapyApi/PatientsPool";

import useAppStore from "@/Modules/App/Store";
import usePatientPoolStore from "@/Modules/PatientsPool/Store";
import useUserStore from "@/Modules/User/Store";

function assigmentPatientAH(customerUuid: string) {
  const appStore = useAppStore();
  const patientsPoolStore = usePatientPoolStore();
  const userStore = useUserStore();

  patientsPoolStore.isLoading = true;

  return postAssigmentPatient(customerUuid)
    .then(() => {
      patientsPoolStore.getPatientsPoolList(userStore.user!.id);

      appStore.showSnackbar({
        type: NotificationType.INFO,
        message: "chat.assignment.confirmation_assignment_msg",
      });
    })
    .catch((error: ApiError) => {
      captureMessage(`Assigment error: ${error.error_code}`);

      if (
        [ApiErrorCodes.CUSTOMER_HAS_THERAPIST, ApiErrorCodes.CUSTOMER_IS_NOW_IN_ASSIGMENT].includes(
          error.error_code as ApiErrorCodes
        )
      ) {
        appStore.showSnackbar({
          type: NotificationType.ERROR,
          message: "chat.assignment.error_assignment_msg",
        });
      } else {
        appStore.showSnackbar({
          type: NotificationType.ERROR,
          message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
        });
      }
    })
    .finally(() => {
      patientsPoolStore.isLoading = false;
    });
}

export default assigmentPatientAH;
